(function () {
    "use strict";

    // --------------------------------------------------
    // DO NOT USE, NOT WORKING YET
    // --------------------------------------------------

    // @ngInject
    function SplitIOServiceCtor(splitio, AppConfigService, UsersManager, AccountsService, Enums) {
        this.splitio = splitio;
        this.AppConfigService = AppConfigService;

        const user = UsersManager.getCurrUser();

        UsersManager.on('loggingIn', this._initialize.bind(this));
        UsersManager.on('loggingOut', this._destroy.bind(this));
        AccountsService.on(Enums.PubSubTriggers.companyChanged, this._initialize.bind(this));
        if (user._id) {
            this._initialize(user);
        }
    }

    Services.SplitIOService = Class(() => {

        return {
            constructor: SplitIOServiceCtor,

            _initialize() {

                const user = this.UsersManager.getCurrUser();

                this._destroy();

                this.__clients = {};

                const client = this._getClient(user._id, 'user');
                client.on(client.Event.SDK_READY, () => {
                    const splits = this._getSplits(user);
                    this.userSplits = {};
                    splits.forEach((split) => {
                        let identification = null;
                        const trafficType = split.trafficType;

                        if (trafficType === 'user') {
                            identification = user._id;
                        } else if (trafficType === 'company') {
                            identification = user.company_id;
                        } else if (trafficType === 'account') {
                            identification = user.account_id;
                        }

                        if (identification) {
                            this.userSplits[split.name] = this._getClient(identification, trafficType).getTreatment(split.name);
                        }
                    });
                });
            },

            _getSplits(user) {
                return this._getManager(user).splits();
            },

            _getClient(id, trafficType) {
                if (!this.__clients[id]) {
                    this.__clients[id] = this.splitio({
                        core: {
                            authorizationKey: this.AppConfigService.appConfiguration().split_io_api_key,
                            key: id,
                            trafficType: trafficType
                        }
                    }).client();
                }

                return this.__clients[id];
            },

            _getManager(user) {
                if (!this.__manager) {
                    this.__manager = this._defaultFactory(user).manager();
                }

                return this.__manager;
            },

            _defaultFactory(user) {
                if (!this.__factory) {
                    this.__factory = this.splitio({
                        core: {
                            authorizationKey: this.AppConfigService.appConfiguration().split_io_api_key
                        }
                    });
                }

                return this.__factory;
            },

            _destroy() {

                if (!this.__clients) {
                    return;
                }

                this.__clients.forEach(client => client.destroy());

                this.__clients = null;
                this.__manager = null;
            }
        };
    });
}());
